__turbopack_context__.v({
  "continueButtonWrapper": "_2G90aG_continueButtonWrapper",
  "loader": "_2G90aG_loader",
});
